$(document).ready(function () {
  $(".js-article-video-play").click(function (e) {
    e.preventDefault();
    var href = $(this).data("src");
    var video_url = $(this).data("video");
    $.fancybox.open({
      src: href,
      type: "inline",
      touch: {
        vertical: false, // Allow to drag content vertically
        momentum: false, // Continue movement after releasing mouse/touch when panning
      },
      opts: {
        beforeShow: function () {
          var video = $(
            '<video autoplay controls="false" preload="none" preload id="my-video" class="video-js vjs-theme-sea"><p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p></video>'
          );
          $(href).append(video);

          var initVideo = function () {
            var vidOpts = {
              controls: true,
              preload: "none",
              autoPlay: true,
              fluid: true,
              loop: true,
              controlBar: {
                volumePanel: { inline: true },
              },
              sources: [{ type: "video/mp4", src: video_url }],
            };

            videojs("my-video", vidOpts, function () {});
            var player = videojs("my-video");
          };

          if (window.theme && window.theme.whenVideoJsReady) {
            window.theme.whenVideoJsReady(initVideo);
          } else {
            initVideo();
          }
        },

        afterShow: function (instance, current) {},
        beforeClose: function () {
          videojs("my-video").dispose();
        },
      },
    });
  });

  function init() {
    searchRelatedVideoBlogs();
  }

  function searchRelatedVideoBlogs() {
    var $container = $(".js-related-video-blogs-container");
    var $wrapper = $container.parents(".article-latest-blogs-wrapper");
    var productHandle = $container.data("product-handle");
    var articleHandle = $container.data("article-handle");

    if (productHandle == "") {
      $wrapper.hide();
      return;
    }

    $.ajax({
      url:
        window.Shopify.routes.root +
        "search?view=blog-ajax&type=article&q=product-video:" +
        productHandle,
      dataType: "json",
      success: function (data) {
        console.log(data);
        const result = buildRelatedVideoBlogs(data, $container, articleHandle);
        if (!result) {
          $wrapper.hide();
        }
      },
      error: function (err) {
        console.log(err);
      },
    });
  }

  function buildRelatedVideoBlogs(data, $container, articleHandle) {
    var items = data.results;
    if (!items || items.length == 0) {
      return false;
    }

    //sort priority
    items.forEach(function (el, index) {
      if (el.priority) {
        items.unshift(items.splice(index, 1)[0]);
      }
    });

    for (var i = 0; i < items.length; i++) {
      console.log("going here");
      var article = items[i];

      if (article.handle == articleHandle) continue;

      var template = $(`<div class="article-latest-blogs-item">
          <a href="${article.url}" class="article-latest-blog-link-wrapper">
            <div>
              <div class="article-latest-blog-image-wrapper">
                <img src="${article.thumb}"></img>
              </div>
            </div>
            <div class="article-latest-blog-text-wrapper">
              <span class="blog-item-tag">${article.category}</span>
              <h4 class="article-lastest-blog-title">${article.title}</h4>
            </div>
          </a>
        </div>`);

      $container.append(template);
    }

    return true;
  }

  init();
});
